import { Permission } from '@Models';
import { RootState, useAppSelector } from '@Store';

/**
 * Whether the signed-in user holds a permission, for gating affordances inside
 * a component. Arrays are any-of, matching both `withValidPermission` and the
 * backend's `ValidatePermission`.
 *
 * Not to be confused with `usePermissions`, which fetches the catalog of
 * permissions that exist in Auth0 for the Users admin screen.
 */
const useHasPermission = (permission: Permission | Permission[]): boolean => {
  const granted = useAppSelector((state: RootState) => state.authorization.permissions);
  if (!Array.isArray(granted)) return false;
  return Array.isArray(permission) ? permission.some((p) => granted.includes(p)) : granted.includes(permission);
};

export default useHasPermission;
